import type { ConversationNodeCallRecording } from 'lib-shared-types-api';

type Props = {
  node: ConversationNodeCallRecording;
};

export function RoutedThroughCallRecording(_: Props): JSX.Element {
  return <>Record conversation</>;
}
